/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CandidateAcademicProgramCompletion,
    CandidateAcademicProgramCompletionFromJSON,
    CandidateAcademicProgramCompletionFromJSONTyped,
    CandidateAcademicProgramCompletionToJSON,
    CandidateDocument,
    CandidateDocumentFromJSON,
    CandidateDocumentFromJSONTyped,
    CandidateDocumentToJSON,
    CandidateLink,
    CandidateLinkFromJSON,
    CandidateLinkFromJSONTyped,
    CandidateLinkToJSON,
    CompanyOfferItem,
    CompanyOfferItemFromJSON,
    CompanyOfferItemFromJSONTyped,
    CompanyOfferItemToJSON,
    Event,
    EventFromJSON,
    EventFromJSONTyped,
    EventToJSON,
} from './';

/**
 * Detalle de candidatura [P_E_07]
 * @export
 * @interface CompanyApplication
 */
export interface CompanyApplication {
    /**
     * 
     * @type {number}
     * @memberof CompanyApplication
     */
    id?: number;
    /**
     * applied, accepted, selected, discarded
     * @type {string}
     * @memberof CompanyApplication
     */
    status?: string;
    /**
     * 
     * @type {Array<Event>}
     * @memberof CompanyApplication
     */
    events?: Array<Event>;
    /**
     * 
     * @type {CompanyOfferItem}
     * @memberof CompanyApplication
     */
    offer?: CompanyOfferItem;
    /**
     * Nombre del candidato
     * @type {string}
     * @memberof CompanyApplication
     */
    name?: string;
    /**
     * Edad del candidato
     * @type {number}
     * @memberof CompanyApplication
     */
    age?: number;
    /**
     * Telefono del candidato
     * @type {string}
     * @memberof CompanyApplication
     */
    phone?: string;
    /**
     * Email del candidato
     * @type {string}
     * @memberof CompanyApplication
     */
    email?: string;
    /**
     * Dirección del candidato - Traida del sis
     * @type {string}
     * @memberof CompanyApplication
     */
    fullAddress?: string;
    /**
     * 
     * @type {CandidateDocument}
     * @memberof CompanyApplication
     */
    document?: CandidateDocument;
    /**
     * 
     * @type {Array<CandidateLink>}
     * @memberof CompanyApplication
     */
    links?: Array<CandidateLink>;
    /**
     * Nota de las respuestas, -1 killer
     * @type {number}
     * @memberof CompanyApplication
     */
    killerGrade?: number;
    /**
     * Indica si las preguntas tienen nota
     * @type {boolean}
     * @memberof CompanyApplication
     */
    hasKillerGrade?: boolean;
    /**
     * Suma de nota de las respuestas. Porcentaje sobre la suma maxima, -1 killer
     * @type {number}
     * @memberof CompanyApplication
     */
    gradePercent?: number;
    /**
     * 
     * @type {Array<CandidateAcademicProgramCompletion>}
     * @memberof CompanyApplication
     */
    academicPrograms?: Array<CandidateAcademicProgramCompletion>;
    /**
     * Copia del texto de la letter
     * @type {string}
     * @memberof CompanyApplication
     */
    letter?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof CompanyApplication
     */
    questions?: Array<object>;
}

export function CompanyApplicationFromJSON(json: any): CompanyApplication {
    return CompanyApplicationFromJSONTyped(json, false);
}

export function CompanyApplicationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyApplication {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'events': !exists(json, 'events') ? undefined : ((json['events'] as Array<any>).map(EventFromJSON)),
        'offer': !exists(json, 'offer') ? undefined : CompanyOfferItemFromJSON(json['offer']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'age': !exists(json, 'age') ? undefined : json['age'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'fullAddress': !exists(json, 'full_address') ? undefined : json['full_address'],
        'document': !exists(json, 'document') ? undefined : CandidateDocumentFromJSON(json['document']),
        'links': !exists(json, 'links') ? undefined : ((json['links'] as Array<any>).map(CandidateLinkFromJSON)),
        'killerGrade': !exists(json, 'killer_grade') ? undefined : json['killer_grade'],
        'hasKillerGrade': !exists(json, 'has_killer_grade') ? undefined : json['has_killer_grade'],
        'gradePercent': !exists(json, 'grade_percent') ? undefined : json['grade_percent'],
        'academicPrograms': !exists(json, 'academic_programs') ? undefined : ((json['academic_programs'] as Array<any>).map(CandidateAcademicProgramCompletionFromJSON)),
        'letter': !exists(json, 'letter') ? undefined : json['letter'],
        'questions': !exists(json, 'questions') ? undefined : json['questions'],
    };
}

export function CompanyApplicationToJSON(value?: CompanyApplication | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'status': value.status,
        'events': value.events === undefined ? undefined : ((value.events as Array<any>).map(EventToJSON)),
        'offer': CompanyOfferItemToJSON(value.offer),
        'name': value.name,
        'age': value.age,
        'phone': value.phone,
        'email': value.email,
        'full_address': value.fullAddress,
        'document': CandidateDocumentToJSON(value.document),
        'links': value.links === undefined ? undefined : ((value.links as Array<any>).map(CandidateLinkToJSON)),
        'killer_grade': value.killerGrade,
        'has_killer_grade': value.hasKillerGrade,
        'grade_percent': value.gradePercent,
        'academic_programs': value.academicPrograms === undefined ? undefined : ((value.academicPrograms as Array<any>).map(CandidateAcademicProgramCompletionToJSON)),
        'letter': value.letter,
        'questions': value.questions,
    };
}


